export default new URL("../images/places/place-3.jpg", import.meta.url).href;